module.exports = __webpack_public_path__ + "img/hero-slide-5.c815e07d.png";